import React, { useEffect, useRef, useState } from 'react';
// styles
import styled, { css } from 'styled-components';
import { TimeIcon } from 'refactored/ui/icons';
import { useClickOutside } from 'refactored/ui/utils';
import { getHoursAndMinutesFromDate, getLabelForRange } from './economyUtils';
import { useTranslation } from 'react-i18next';

const Input = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;
  height: 48px;
  box-sizing: content-box;
`;

const IconContainer = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 48px;
  height: 48px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */
`;

const InputValueContainer = styled.div`
  /* box-sizing: border-box; */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 12px 2px;
  gap: 12px;

  /* width: 228px; */
  width: 100%;
  /* height: 48px; */

  /* secondary / white */

  background: #ffffff;
`;

const InputValue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;

  /* width: 204px; */
  height: 40px;
`;

const InputValueLabel = styled.div`
  height: 16px;

  /* 12px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: flex;
  align-items: center;

  /* grey / 500 */

  color: #94a6b8;
`;

const InputValueText = styled.div`
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* grey / 900 */

  color: #263340;
`;

const LightColorText = styled.div`
  color: var(--grey500);
  margin-left: 4px;
`;

const Dropdown = styled.div`
  border: 1px solid green;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  max-height: 240px;
  overflow: auto;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;
`;

const DropdownItem = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px;
  gap: 10px;

  width: 100%;
  height: 40px;

  /* grey / 200 */

  background: white;

  cursor: pointer;

  border-bottom: 1px solid #e2e8ee;
  &:hover {
    background: #e0eaff;
  }
  ${(props) =>
    !!props.isSelected &&
    css`
      background: var(--grey300);
      &:hover {
        background: var(--grey300);
      }
    `};
`;

const SoRangePicker = ({
  className,
  timeFrom,
  timeTo,
  availableTimes,
  selectFunction,
}) => {
  const { t } = useTranslation('Catalog');

  const clickRef = React.useRef();
  useClickOutside(clickRef, () => {
    setIsOpened(false);
  });
  const [isOpened, setIsOpened] = useState(false);

  const selectOption = (range) => {
    selectFunction(range);
    setIsOpened(false);
  };

  const displayTimeFrom = getHoursAndMinutesFromDate(timeFrom);
  const displayTimeTo = getHoursAndMinutesFromDate(timeTo);

  const refScroll = useRef(null);

  const selectedLabelFrom = getLabelForRange(timeFrom, timeTo);

  useEffect(() => {
    if (isOpened) {
      try {
        refScroll.current.scrollIntoView();
      } catch (e) {
        console.error('🔥 ~ e:', e);
      }
    }
  }, [isOpened]);

  return (
    <div className={className}>
      <Input onClick={() => setIsOpened(!isOpened)} ref={clickRef}>
        <IconContainer>
          <TimeIcon />
        </IconContainer>

        <InputValueContainer>
          <InputValue>
            <InputValueLabel>{t('price.between')}</InputValueLabel>
            <InputValueText>
              {displayTimeFrom}
              <LightColorText> - {displayTimeTo}</LightColorText>
            </InputValueText>
          </InputValue>
        </InputValueContainer>
      </Input>
      {isOpened && (
        <Dropdown>
          {availableTimes.map((range) => {
            const isItemSelected =
              range.label.labelFrom === selectedLabelFrom.labelFrom &&
              range.label.labelTo === selectedLabelFrom.labelTo;
            return (
              <DropdownItem
                isSelected={isItemSelected}
                onClick={() => selectOption(range)}
                ref={isItemSelected ? refScroll : null}
              >
                <InputValueText>
                  {range.label.labelFrom}
                  <LightColorText> - {range.label.labelTo}</LightColorText>
                </InputValueText>
              </DropdownItem>
            );
          })}
        </Dropdown>
      )}
    </div>
  );
};

export default styled(SoRangePicker)`
  /* border: 1px solid black; */
  width: 100%;
  position: relative;
`;

// a las 21:18
